import { IScheduler } from './types'
import { ListPanelWrapper } from '../../components/ListPaneWrapper';
import { SmallPanel } from './SmallPanel';
import { IoCalendarOutline } from 'react-icons/io5';
import useIsMobile from '../../../hooks/useIsMobile/useIsMobile';
import { ValueDisplayWithLabel } from '../../components/ValueDisplay';
import { themedUseStyletron } from '../../../theme/customTheme';
import { useIntl } from 'react-intl';
import { getValue } from './utils';
import { StateText } from './StateText';

export function ListPanel(props: IScheduler) {
    const mobile = useIsMobile();
    const [css, theme] = themedUseStyletron();

    return (
        <ListPanelWrapper icon={<IoCalendarOutline size={'100%'} color={theme.colors.backgroundPrimary}></IoCalendarOutline>} {...props}>
            <>
                {!mobile && <SmallPanel {...props}></SmallPanel>}
                {mobile && <StateText {...props}></StateText>}
            </>
        </ListPanelWrapper>
    );
}